import { useTranslation } from '@frontend/i18n';
import { AudienceTray } from '../audience-tray/audience-tray';
import { useAudienceTray } from '../providers/audience-tray-provider';

export const ListsViewHeader = () => {
  const { t } = useTranslation('bulk-messaging');
  const { enableManualSelection } = useAudienceTray();
  return <AudienceTray.Header title={enableManualSelection ? t('Select Recipients') : t('Create Audience')} />;
};
